import * as WatchApiService from '../services/api/requests/Watch'

// import { DASHBOARD_MOVIES } from '../services/data/errorNames.json'

// // data
// const CINEMA_NOW_SHOWING = {
//   title: 'Now Showing',
//   description:
//     'Find movies currently showing in an Ayala Malls cinema near you. Book your tickets quick and easy.',
//   movies: true,
// }
// const CINEMA_COMING_SOON = {
//   title: 'Coming Soon',
//   description: 'Find movies coming soon to an Ayala Malls cinema near you.',
//   movies: true,
// }
// const CINEMA_FEATURED = {
//   title: 'Top Picks',
// }

// get ticket count
export const doGetTicketCount = async ({
  accessToken,
  setTicketCount = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => {
  // REMOVED - getTicketsCount function no longer exists
  // try {
  //   const response = await WatchApiService.getTicketsCount(accessToken)
  //   const { value } = response.value || {}
  //   setTicketCount(value)
  //   onSuccess(response)
  // } catch (err) {
  //   onError(err)
  // }
  setTicketCount(0)
}

// <-- [Web] Remove Watch Module - ST-7932
// get section title for cinema page/feature

// export const doGetCinemaSections = () => ({
//   nowShowing: CINEMA_NOW_SHOWING,
//   comingSoon: CINEMA_COMING_SOON,
//   featured: CINEMA_FEATURED,
// })

// gets dashboard cinema posters
// export const doGetDashboardCinema = ({
//   setMovies,
//   setError,
//   errorList,
//   removeError,
//   accessToken,
//   onSuccess = () => {},
// }) => async limit => {
//   if (errorList.length) {
//     removeError(DASHBOARD_MOVIES)
//   }
//   await WatchApiService.getAllMovies(accessToken, limit)
//     .then(response => {
//       const responseData = Array.from(response.data.nowShowing)
//       setMovies(responseData.reverse())
//       onSuccess(responseData)
//     })
//     .catch(error => {
//       setError({
//         name: DASHBOARD_MOVIES,
//         error: error.message,
//       })
//     })
// }

// // get cinemas
// export const doGetCinemas = async ({
//   setCinemas,
//   onSuccess = () => {},
//   onError = () => {},
// }) => {
//   try {
//     const response = await WatchApiService.getCinemas()
//     setCinemas(response.data)
//     // TODO: setGAEvent
//     onSuccess(response)
//   } catch (e) {
//     onError(e)
//   }
// }

// // get all movies
// export const doGetAllMovies = ({
//   accessToken,
//   setNowShowing = () => {},
//   setComingSoon = () => {},
//   onSuccess = () => {},
//   onError = () => {},
// }) => async (limit, watchSlug) => {
//   try {
//     const response = await WatchApiService.getAllMovies(
//       accessToken,
//       limit,
//       watchSlug,
//     )
//     const { comingSoon, nowShowing } = response
//     const responseData = Array.from(comingSoon)
//     setNowShowing(nowShowing)
//     setComingSoon(responseData.reverse())
//     onSuccess(response)
//   } catch (error) {
//     onError(error)
//   }
// }

// // gets movie data for modal
// export const doGetMovieData = ({
//   movieModalData,
//   setMovieModalData = () => {},
//   setMovieModalStatus = () => {},
//   onSuccess = () => {},
//   onError = () => {},
// }) => async movieId => {
//   if (!movieModalData) {
//     setMovieModalStatus(1)
//     try {
//       const response = await WatchApiService.getMovie(movieId)
//       movieModalData = response.data
//       onSuccess(response)
//     } catch (e) {
//       setMovieModalStatus(4)
//       onError(e)
//     }
//   }
//   setMovieModalData(movieModalData)
//   setMovieModalStatus(0)
// }

// // gets list of now showing
// export const doGetNowShowingList = async ({
//   accessToken,
//   setCardListModalData = () => {},
//   setCardListModalStatus = () => {},
//   onSuccess = () => {},
//   onError = () => {},
//   callback = () => {},
// }) => {
//   let cardListModalData = []
//   setCardListModalStatus(1)
//   await doGetMovieData({
//     accessToken,
//   })
//   try {
//     const response = await WatchApiService.getAllMovies(accessToken)
//     cardListModalData = response.data ? response.data.nowShowing : null
//     onSuccess(response)
//   } catch (e) {
//     setCardListModalStatus(4)
//     onError(e)
//   }

//   callback()

//   setCardListModalData(cardListModalData)
//   setCardListModalStatus(0)
// }

// // gets list of coming soon
// export const doGetComingSoonList = async ({
//   accessToken,
//   setCardListModalData = () => {},
//   setCardListModalStatus = () => {},
//   onSuccess = () => {},
//   onError = () => {},
//   callback = () => {},
// }) => {
//   let cardListModalData = []
//   setCardListModalStatus(1)
//   await doGetMovieData({
//     accessToken,
//   })
//   try {
//     const response = await WatchApiService.getAllMovies(accessToken)
//     cardListModalData = response.data ? response.data.comingSoon : null
//     onSuccess(response)
//   } catch (e) {
//     setCardListModalStatus(4)
//     onError(e)
//   }

//   callback()

//   setCardListModalData(cardListModalData)
//   setCardListModalStatus(0)
// }

// [Web] Remove Watch Module - ST-7932 -->
